var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card__info"},[_vm._t("head")],2),_c('div',{staticClass:"card__contacts"},[_vm._t("contacts")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }